<template>
  <div>
    <canvas ref="qrcodeCanvas"></canvas>
  </div>
</template>

<script>
  import QRCode from 'qrcode'

  export default {
    name: 'QrCodeComponent',
    props: {
      text: {
        type: String,
        required: true
      }
    },
    mounted() {
      this.generateQRCode()
    },
    methods: {
      generateQRCode() {
        const canvas = this.$refs.qrcodeCanvas
        QRCode.toCanvas(canvas, this.text,{margin : 0})
      }
    }
  }
</script>

<style scoped>
  canvas{
    width: 100% !important;
    height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/QRCode.vue